export default __webpack_public_path__ + "static/media/L6.e081ea68.webp";